import { buildBitmap } from "./bitmap";
import { formatTransmissionTime } from "@utils/time";

export type ISOFields = {
  [field: number]: any;
};

export type ISOMessage = {
  mti: string;
  bitmap: string;
  fields: ISOFields;
};

/**
 * Build a structured ISO 8583 message
 */
export function buildISOMessage(input: {
  pan: string;
  amount: number;
  transmissionTime: string;
  stan?: string;
  terminalId?: string;
  processingCode?: string;
  expiry?: string;
  posEntryMode?: string;
  track2?: string;
  currencyCode?: string;
  emvData?: string;
}): ISOMessage {
  const fields: ISOFields = {
    2: input.pan,
    3: input.processingCode || "000000",
    4: input.amount.toString().replace(".", "").padStart(12, "0"), // ISO amounts are usually implied decimals
    7: formatTransmissionTime(),
    11: input.stan ?? generateSTAN(),
    14: input.expiry ? input.expiry.substring(0, 4) : "2812", // YYMM
    22: input.posEntryMode || "051",
    35: input.track2,
    41: input.terminalId ?? "TERM001",
    49: input.currencyCode === "USD" ? "840" : "000"
  };

  if (input.emvData) {
    fields[55] = input.emvData;
  }

  // Remove undefined fields
  Object.keys(fields).forEach(k => {
    if (fields[Number(k)] === undefined) delete fields[Number(k)];
  });

  const bitmap = buildBitmap(fields);

  return {
    mti: "0100",
    bitmap,
    fields
  };
}

function generateSTAN(): string {
  return Math.floor(Math.random() * 1_000_000)
    .toString()
    .padStart(6, "0");
}